import { render } from "./PresoBlock.vue?vue&type=template&id=2549cf52"
import script from "./PresoBlock.vue?vue&type=script&lang=js"
export * from "./PresoBlock.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\sistema-denuncias\\public\\apps\\presos-politicos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__